const config = {
    api: 'https://strapi.zsspecialnivm.cz'
}

export default config;